
    import { mapState } from 'vuex';
    import JobCardBasic from '@/components/Job/JobCard/JobCardBasic';
    import GetJobMatchesPromptShort from '@/components/Prompts/Components/GetJobMatchesPromptShort';
    import AdUnit from '@/components/Ad/AdUnit';

    export default {
        name: 'JobScroll',

        components: {
            JobCardBasic,
            GetJobMatchesPromptShort,
            AdUnit,
        },

        props: {
            jobs: {
                type: Array,
                required: true,
            },

            to: {
                type: String,
                default: '',
            },

            toLabel: {
                type: String,
                default: '',
            },

            rowLabel: {
                type: String,
                default: '',
            },

            rowType: {
                type: String,
                default: '',
            },

            rowTypeId: {
                type: String,
                default: '',
            },

            rowPosition: {
                type: Number,
                default: 0,
            },
        },

        data() {
            return {
                id: this._uid,
                jobMutable: [],
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
            }),

            hasRowTypeIdSlot() {
                return !!this.$slots[this.rowTypeId];
            },
        },

        watch: {
            jobs() {
                this.$nextTick(() => {
                    this.cloneJobs();
                });
            },
        },

        created() {
            this.cloneJobs();
        },

        methods: {
            cloneJobs() {
                this.jobMutable = JSON.parse(JSON.stringify(this.jobs));

                // Add a fake job at the end
                if (this.jobMutable.length >= 20) {
                    this.jobMutable.push({
                        uuid: 'fakeJob',
                    });
                }
            },
        },
    };
